var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table mt-1 table-hover table-sm" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l([..._vm.errors, ..._vm.pass], function (r, i) {
          return _c("tr", { class: { "bg-warning": !!r.message } }, [
            _c("td", [_vm._v(_vm._s(i + 1))]),
            _vm._v(" "),
            _c(
              "td",
              [
                r.order_id
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-xs btn-info ml-1 mr-2",
                          on: {
                            click: function ($event) {
                              return _vm.openOrderToEdit(r.order_id)
                            },
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                      ),
                      _vm._v(
                        "\n          " + _vm._s(r.order_id) + "\n        "
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", [_vm._v(_vm._s(r.message))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(r.index))]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("p", [_vm._v("тел: " + _vm._s(r.phone))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(r.address))]),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сообщение")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }